<template>
  <div :class="['reportList', isCousePage && 'padd', isCousePage && !getMenuWay && 'hasM']" @click="currDelI = null">
    <div class="content flex-v">
      <div :class="['hBox flex', isEmpty && 'hBox2']" v-if="!assignFlag">
        <div class="emptyBox" v-if="isCousePage">
          <Empty title="暂未布置练习任务" v-if="isEmpty"></Empty>
        </div>
        <template v-else>
          <h2>
            课后练习
            <span class="tips" v-if="isEmpty"
              >还没有布置过课后练习哦，快点来布置一下吧～</span
            >
          </h2>
          <p class="txt" v-if="!isEmpty" @click="toAssign">
            <img
              class="icon"
              src="https://llss-file.langsounds.com/miniapp/ab3c18f43f7cd0e5685e9e3324b4b780.png"
              alt=""
            />
            布置课后练习
          </p>
          <div class="emBox flex-v" v-else @click="toAssign">
            <img
              class="icon1"
              src="https://llss-file.langsounds.com/miniapp/ab3c18f43f7cd0e5685e9e3324b4b780.png"
              alt=""
            />
            布置朗读任务
          </div>
        </template>
      </div>
      <div class="box hideScrollbar" v-if="!isEmpty">
        <ul
          class="rList"
          v-infinite-scroll="load"
          :infinite-scroll-disabled="disabled"
        >
          <li
            v-for="(item, i) in list"
            class="rItem"
            @click="checkDetail(item.homeworkId)"
          >
            <div class="itemH flex">
              <span class="lab">{{ item.type === 1 ? "朗读" : "背诵" }}</span>
              <div class="edit">
                <img
                  class="icon"
                  src="~/images/edit.png"
                  alt=""
                  @click.stop="currDelI = i"
                />
                <p
                  class="delBox flex-center"
                  v-if="currDelI === i"
                  @click.stop="isShowDel = true"
                >
                  <img class="del" src="~/images/删除@2x.png" alt="" />删除
                </p>
              </div>
            </div>
            <p class="line1 title">{{ item.title }}</p>
            <div class="bottInfo flex-center">
              <p>
                <span class="grade">{{ item.gradeTxt }}</span>
                <span class="time">{{ item.createTime }}</span>
              </p>
              <div class="flex">
                <p class="cItem flex-v">
                  <span class="num">{{ item.yesSubmitCount || 0 }}</span>
                  <span class="txt">已交</span>
                </p>
                <p class="cItem flex-v">
                  <span class="num">{{ item.noSubmitCount || 0 }}</span>
                  <span class="txt">未交</span>
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="empty flex-v" v-else>
        <img class="detailImg" src="~/images/编组 35@2x (1).png" alt="" />
        <div class="empTxt">暂未布置练习任务</div>
        <div class="emptyBtn" @click="$emit('goAssign')">布置朗读练习</div>
      </div> -->
      <div class="gradeTab flex" v-if="isShowAll">
        <li
          :class="['item', currGradeItem.id === item.id && 'active']"
          @click="changeGrade(item)"
          v-for="(item, i) in gradeList"
          :key="i"
        >
          {{ item.labelTxt }}
        </li>
      </div>
    </div>
    <!-- 删除二次确认弹窗 -->
    <VMask v-model="isShowDel">
      <div class="delCont flex-v" @click.stop="">
        <h2>确认删除任务</h2>
        <p>删除后，该练习任务的报告记录将会清空！</p>
        <div class="btnBox flex">
          <span class="cancel" @click.stop="cancel">取消</span>
          <span class="sure" @click.stop="sure">确认删除</span>
        </div>
      </div>
    </VMask>

    <!-- 布置练习 -->
    <Dialog
      title="布置朗读练习"
      width="40%"
      top="15vh"
      :modal="true"
      :modal-append-to-body="false"
      :visible.sync="isShowAssign"
    >
      <AssignTask ref="taskRef" @sureAssign="sureAssign" @onPrev="onPrev"></AssignTask>
    </Dialog>
    <Preview ref="prevRef"/>
  </div>
</template>
<script>
import VMask from "base/mask";
import util from "libs/util";
import AssignTask from "./assignTask.vue";
import { Dialog } from "element-ui";
import Preview from 'business/Preview';
import Empty from "business/Empty";
import { mapGetters } from 'vuex';

export default {
  props: {
    isCousePage: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VMask,
    Dialog,
    AssignTask,
    Preview,
    Empty
  },
  data() {
    return {
      currGradeItem: {},
      count: 10,
      isShowDel: false,
      gradeList: [],
      isEmpty: false,
      pageNum: 1,
      list: [],
      currDelI: null,
      lastPage: true,
      loading: false,
      isShowAssign: false, // 布置作业弹窗
      classesId: null,
      schoolId: '',
      isShowAll: true,
      assignFlag: false,
    };
  },
  computed: {
    ...mapGetters([
      "getMenuWay",
    ]),
    disabled() {
      return this.loading || this.lastPage;
    },
  },
  watch: {
    classesId(val) {
      console.log("-------classesId------", val);
      // if (val) this.getList(1, val);
    },
    isShowAssign(val) {
      if (!val) this.$refs.taskRef.resetData();
    }
  },
  methods: {
    onPrev(v1,v2) {
      this.$refs.prevRef?.openPreview(v1,v2);
    },
    // 布置练习
    toAssign() {
      this.isShowAssign = true;
      this.classesId = null;
    },
    // 布置作业sure
    sureAssign(id) {
      this.isShowAssign = false;
      this.classesId = id;
      this.getList(1);
    },
    // 切换年级
    changeGrade(item) {
      this.currGradeItem = item;
      this.classesId = item.id;
      this.getList(1);
    },
    tapDel(i) {
      if (this.currDelI === i) return this.currDelI = null;
      this.currDelI = i;
    },
    load() {
      this.loading = true;
      if (!this.lastPage) {
        this.pageNum++;
        this.getList();
      }
    },
    // 查看详情
    checkDetail(homeworkId) {
      this.$emit("checkDetails", homeworkId);
    },
    cancel() {
      this.isShowDel = false;
      this.currDelI = null;
    },
    async sure() {
      this.$loading.show();
      this.isShowDel = false;
      const res = await this.$get("/homework/del.json", {
        homeworkId: this.list[this.currDelI].homeworkId,
      });
      if (res.status == 200) {
        console.log(this.currDelI);
        this.list.splice(this.currDelI, 1);
        console.log(this.list);
        this.$toast("删除成功！");
      } else {
        this.$toast(res.message);
      }
      this.$loading.hide();
      this.isEmpty = !this.list.length;
      this.currDelI = null;
    },
    
    async getList(isReset, classesId) {
      try {
        if (isReset) {
          this.pageNum = 1;
          this.list = [];
        }
        // if (classesId && this.gradeList.length) {
        //   let arr =
        //     this.gradeList.filter((item) => {
        //       return item.id == classesId;
        //     }) || [];
        //   this.currGradeItem = { ...arr[0] };
        // }

        // 布置完作业后回显当前布置的班级
        // if (this.classesId && this.gradeList.length) {
        //   let arr =
        //     this.gradeList.filter((item) => {
        //       return item.id == classesId;
        //     }) || [];
        //   this.currGradeItem = { ...arr[0] };
        // }
        await this.loadClasses();
        // if (!isReset && this.pageNum === 1 && !classesId && this.isShowAll) {
        //   const res = await this.$get("/home/classesList.json", {schoolId: this.schoolId || null});
        //   if (res.status == 200) {
        //     res.data?.length &&
        //       res.data.map((item) => {
        //         item.labelTxt = `${
        //           item?.name?.includes("年级")
        //             ? item.name
        //             : util.gradeNumToText(item.grade) + item.name
        //         }`;
        //       });
        //     this.gradeList = [{ id: 0, labelTxt: "全部" }, ...res.data];
        //     this.currGradeItem = this.gradeList[0] || {};
        //     console.log('班级', this.gradeList)
        //   }
        // }
        // if (!this.gradeList.length && this.isShowAll) return this.$toast("暂无班级数据");
        this.$loading.show();
        const lRes = await this.$post("/home/homeworkList.json", {
          // classesId: classesId || this.currGradeItem.id,
          // classesId: this.currGradeItem.id,
          classesId: this.classesId,
          schoolId: this.schoolId || '',
          pageNum: this.pageNum,
          pageSize: 20,
        });
        if (lRes.status == 200) {
          console.log(lRes);
          this.lastPage = lRes.data.lastPage;
          lRes.data.list.map(item => {
            item.gradeTxt = `${
              item?.classesName?.includes("年级")
                ? item.classesName
                : util.gradeNumToText(item.grade) + item.classesName
            }`;
          });
          this.list = [...this.list, ...lRes.data.list];
        } else this.$toast(lRes.message);
        this.isEmpty = !this.list.length;
        this.loading = false;
        this.$loading.hide();
        
      } catch (error) {
        
      }
    },
    async loadClasses() {
      try {
        if (this.classesId && this.gradeList.length) {
          let arr =
            this.gradeList.filter((item) => {
              return item.id == this.classesId;
            }) || [];
          this.currGradeItem = { ...arr[0] };
          return;
        }
        if (this.pageNum > 1) return;
        const res = await this.$get("/homework/classesList.json", { schoolId: this.schoolId || null });
        if (res.status == 200) {
          res.data?.length &&
            res.data.map((item) => {
              item.labelTxt = `${
                item?.name?.includes("年级")
                  ? item.name
                  : util.gradeNumToText(item.grade) + item.name
              }`;
            });
          this.gradeList = [{ id: 0, labelTxt: "全部" }, ...res.data];
          this.currGradeItem = this.gradeList[0] || {};
          console.log('班级', this.gradeList)
        }
      if (!this.gradeList.length) return this.$toast("暂无班级数据");
        
      } catch (error) {
        
      }
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    let classesId = +params.get('classesId') || 0;
    this.isShowAll = !classesId;
    this.classesId = classesId;
    this.schoolId = +params.get('schoolId') || '';
    this.assignFlag = params.get('assignFlag');
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.reportList {
  width: 100%;
  height: 100%;

  // &.padd{
  //   padding-left: 70px;
  //   box-sizing: border-box;
  // }

  // &.hasM{
  //   padding-left: 190px;
  // }

  .content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 60px 80px 0 0;
    box-sizing: border-box;

    .hBox {
      flex: auto;
      justify-content: space-between;
      color: #333333;
      font-size: 24px;
      margin-bottom: 41px;
      margin-left: 5px;
      cursor: pointer;

      &.hBox2 {
        flex-direction: column;
        justify-content: flex-start;
      }

      .emptyBox{
        display: flex;
        flex: auto;
        justify-content: center;
      }

      .tips {
        color: #666666;
        font-size: 16px;
        margin-left: 32px;
      }

      .txt {
        width: 180px;
        height: 50px;
        background: #ffffff;
        box-shadow: 0px 16 19px -5px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        text-align: center;
        line-height: 50px;
        color: #FB7C33;
        font-size: 20px;

        .icon {
          width: 21px;
          height: 21px;
        }
      }

      .emBox {
        margin-top: 45px;
        width: 530px;
        height: 208px;
        background: rgba(255, 255, 255, 0.5);
        box-shadow: 0px 16 19px -5px rgba(0, 0, 0, 0.06),
          inset 0px 1 4px 1px #ffffff;
        border-radius: 10px;
        border: 1px solid #ffffff;
        backdrop-filter: blur(4px);
        justify-content: center;
        color: #FB7C33;
        font-size: 24px;
        align-items: center;

        .icon1 {
          width: 61px;
          height: 61px;
        }
      }
    }

    .box {
      height: calc(100% - 120px);
      overflow: auto;

      .rList {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        // padding-top: 60px;
        // box-sizing: border-box;

        .rItem {
          // width: 530px;
          width: 32%;
          height: 208px;
          background: #fffcf7;
          box-shadow: 0px 0px 10px 1px rgba(189, 94, 39, 0.05),
            inset 0px 0px 33px 10px rgba(255, 255, 255, 0.5);
          border-radius: 10px;
          // margin: 0 24px 24px 0;
          margin: 0 0.5% 24px;
          padding: 22px 16px 29px 33px;
          box-sizing: border-box;
          overflow: hidden;

          // &:nth-child(3n) {
          //   margin-right: 0;
          // }

          .itemH {
            justify-content: space-between;
            color: #333333;

            .lab {
              width: 60px;
              height: 31px;
              background: rgba(251, 124, 51, 0.1);
              text-align: center;
              line-height: 31px;
              font-size: 18px;
              color: #7b3a0a;
            }

            .edit {
              position: relative;
              cursor: pointer;
              .icon {
                width: 32px;
                height: 32px;
              }

              .delBox {
                width: 117px;
                height: 65px;
                position: absolute;
                right: -10px;
                top: 20px;
                font-size: 14px;
                color: #666666;
                border-radius: 4px;
                background: url("~images/删除切图@2x.png") no-repeat;
                background-size: contain;

                .del {
                  width: 17px;
                  height: 16px;
                  margin-right: 4px;
                }
              }
            }
          }

          .title {
            font-size: 26px;
            font-weight: bold;
            margin-top: 25px;
          }

          .bottInfo {
            justify-content: space-between;
            .grade {
              font-size: 18px;
              margin-right: 18px;
              line-height: 40px;
            }
            .time {
              color: #999999;
              font-size: 16px;
              white-space: nowrap;
            }

            .cItem {
              align-items: center;
              min-width: 70px;
              position: relative;

              &:first-child {
                &::after {
                  content: "";
                  width: 1px;
                  height: 30px;
                  background: #eeeeee;
                  position: absolute;
                  top: 50%;
                  right: 0;
                  transform: translateY(-50%);
                }
              }
              .num {
                font-size: 31px;
                font-weight: bold;
              }

              .txt {
                color: #666666;
                font-size: 18px;
              }
            }
          }
        }
      }
    }

    .gradeTab {
      flex-shrink: 0;
      align-self: center;
      max-width: 80%;
      height: 120px;
      padding: 0 24px;
      box-sizing: border-box;
      overflow-x: auto;
      align-items: center;

      .item {
        min-width: 150px;
        flex-shrink: 0;
        height: 40px;
        background: rgba(251, 124, 51, 0.1);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        color: #FB7C33;
        margin: 0 12px;
        font-size: 16px;
        cursor: pointer;
        padding: 0 30px;
        box-sizing: border-box;

        &.active {
          background: #FB7C33;
          color: #ffffff;
        }
      }
    }

    .empty {
      height: 100%;
      justify-content: center;
      align-items: center;
      .emptyBtn {
        width: 240px;
        height: 40px;
        background: #FB7C33;
        border-radius: 20px;
        line-height: 40px;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
        margin-top: 10px;
      }

      .empTxt {
        color: #999999;
        font-size: 12px;
        margin-top: 30px;
      }
      .detailImg {
        width: 760px;
        height: 221px;
        object-fit: contain;
      }
    }
  }
}
.delCont {
  width: 600px;
  height: 300px;
  background: #fffcf7;
  box-shadow: 0px 0px 10px 1px rgba(189, 94, 39, 0.05),
    inset 0px 0px 33px 10px rgba(255, 255, 255, 0.5);
  border-radius: 16px;
  align-items: center;
  padding: 40px 0;
  box-sizing: border-box;

  h2 {
    color: #333333;
    font-size: 24px;
    font-weight: bold;
  }

  p {
    margin-top: 32px;
    color: #666666;
    font-size: 20px;
  }

  .btnBox {
    margin-top: 80px;
    span {
      font-size: 16px;
      line-height: 50px;
      text-align: center;
      border-radius: 25px;
      height: 50px;
      box-shadow: 0px 0px 10px 1px rgba(189, 94, 39, 0.05);
      cursor: pointer;

      &.cancel {
        width: 160px;
        background: #ffffff;
        color: #999999;
        margin-right: 16px;
      }

      &.sure {
        width: 260px;
        background: #ff4000;
        color: #ffffff;
      }
    }
  }
}
</style>
